import { motion } from 'framer-motion';
import { Facebook, Twitter, Instagram, Linkedin, Mail } from 'lucide-react';

export const Footer = () => {
  const footerLinks = {
    Products: ['All Laptops', 'Dell', 'HP', 'Lenovo', 'Apple'],
    Company: ['About Us', 'Our Story', 'Warranty', 'Contact'],
    Support: ['FAQ', 'Shipping', 'Returns', 'Support'],
    Legal: ['Privacy Policy', 'Terms of Service', 'Cookie Policy'],
  };

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
  ];

  return (
    <footer className="bg-card/50 border-t border-primary/20 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-web-pattern opacity-10" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-12">
          {/* Brand Column */}
          <div className="col-span-2">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center space-x-2 mb-4"
            >
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center glow-red-sm">
                <span className="text-primary-foreground font-bold text-lg">CL</span>
              </div>
              <div>
                <span className="text-foreground font-bold text-lg font-['Exo_2']">
                  CLASSIC LAPTOP
                </span>
                <br />
                <span className="text-primary font-bold text-lg font-['Exo_2']">
                  MALL
                </span>
              </div>
            </motion.div>
            <p className="text-muted-foreground text-sm mb-4 max-w-xs">
              Premium refurbished laptops with hero-level performance. Quality you can trust.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <motion.a
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    whileHover={{ scale: 1.1, y: -2 }}
                    className="w-9 h-9 bg-primary/10 hover:bg-primary/20 rounded-lg flex items-center justify-center transition-colors border border-primary/20 hover:border-primary/40"
                  >
                    <Icon className="w-4 h-4 text-primary" />
                  </motion.a>
                );
              })}
            </div>
          </div>

          {/* Links Columns */}
          {Object.entries(footerLinks).map(([category, links], index) => (
            <div key={category}>
              <h3 className="font-bold text-foreground mb-4">{category}</h3>
              <ul className="space-y-2">
                {links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href="#"
                      className="text-muted-foreground hover:text-primary transition-colors text-sm"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Newsletter Section */}
        <div className="border-t border-primary/20 pt-8 mb-8">
          <div className="max-w-md mx-auto text-center">
            <h3 className="text-xl font-bold mb-2 font-['Exo_2']">
              Stay Updated
            </h3>
            <p className="text-muted-foreground text-sm mb-4">
              Get the latest deals and product updates delivered to your inbox.
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-2 bg-background/50 border border-primary/20 rounded-lg focus:outline-none focus:border-primary text-sm"
              />
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-6 py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg font-medium text-sm transition-colors flex items-center"
              >
                <Mail className="w-4 h-4 mr-2" />
                Subscribe
              </motion.button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        
      </div>
    </footer>
  );
};